// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using their file name.

// eager required, otherwise `BaseCenteredLayout` and `BaseIcon` are used before they have been registered
const modules = import.meta.glob('./Base*.vue', {eager: true})

export function registerBaseComponents(app) {
	for (const path in modules) {
		const componentName = path.replace(/\.\w+$/, '').replace('./', '')
		const module = modules[path]?.default
		if (module) app.component(componentName, module)
	}
}
